﻿const axios = require('axios');

class Importcsv {
    Init() {
        var inst = this;
        $('.jsImportCSVSignupBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.jsImportCSVSignupBtn($(this));
            });
        });
    }

    convertToJsonObject(arrayData) {
        var indexed_array = {};

        $.map(arrayData, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    jsImportCSVSignupBtn(e) {
        var imgLoading = document.getElementById("imgLoading");
        imgLoading.style.visibility = "visible";
        $('#divImportCSV').children().attr("disabled", "disabled");
        let form = $(e).closest("form")[0];
        let bodyFormData1 = new FormData();

        if ($("#files").prop('files')[0] == null) {
            var errorMessage = document.getElementById('importcsv-error-message');
            if (errorMessage) {
                errorMessage.innerText = 'Please Select CSV File To Import Accounts';
                errorMessage.style.display = "block";
                var imgLoading = document.getElementById("imgLoading");
                imgLoading.style.visibility = "hidden";
                $('#divImportCSV').children().attr("disabled", false);
            }
            return false;
        }
        
        bodyFormData1.set('Files', $("#files").prop('files')[0]);
        bodyFormData1.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());
        
        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData1,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response1) {
                if (response1.data) {
                    if (response1.data.success) {
                        var imgLoading = document.getElementById("imgLoading");
                        imgLoading.style.visibility = "hidden";
                        $('#divImportCSV').children().attr("disabled", false);
                        $('#importcsv-success-message').css("display", "block");
                        $('#importcsv-error-message').css("display", "none");
                        
                        var accountCount;
                        var emailCount;
                        var accountErrorCount;
                        var parentOrgErrorCount;
                        
                        if (response1.data.errors["Account"] === undefined || response1.data.errors["Account"] === '') {
                        } else {
                            for (accountCount = 0;
                                accountCount < response1.data.errors["Account"].length;
                                accountCount++) {
                                $('#addedAccounts')
                                    .append(response1.data.errors["Account"][accountCount] + '<br />');
                            }
                        }
                        if (response1.data.errors["Email"] === undefined || response1.data.errors["Email"] === '') {
                        } else {
                            for (emailCount = 0; emailCount < response1.data.errors["Email"].length; emailCount++) {
                                $('#updatedAccounts').append(response1.data.errors["Email"][emailCount] + '<br />');
                            }
                        }
                        if (response1.data.errors["AccountError"] === undefined ||
                            response1.data.errors["AccountError"] === '') {
                        } else {
                            for (accountErrorCount = 0;
                                accountErrorCount < response1.data.errors["AccountError"].length;
                                accountErrorCount++) {
                                $('#importcsv-success-message')
                                    .append(response1.data.errors["AccountError"][accountErrorCount] + '<br />');
                            }
                        }
                        if (response1.data.errors["ParentOrg"] === undefined ||
                            response1.data.errors["ParentOrg"] === '') {
                        } else {
                            for (parentOrgErrorCount = 0;
                                parentOrgErrorCount < response1.data.errors["ParentOrg"].length;
                                parentOrgErrorCount++) {
                                $('#importcsv-success-message')
                                    .append(response1.data.errors["ParentOrg"][parentOrgErrorCount] + '<br />');
                            }
                        }
                    } else {
                        var extensionCount;
                        if (response1.data.errors["FileErrorType"] === undefined || response1.data.errors["FileErrorType"] === '') {
                            var errorMessage = document.getElementById('importcsv-error-message');
                            if (errorMessage) {
                                errorMessage.innerText = '';
                                var imgLoading = document.getElementById("imgLoading");
                                imgLoading.style.visibility = "hidden";
                                $('#divImportCSV').children().attr("disabled", false);
                                $('#importcsv-success-message').css("display", "none");
                                $('#importcsv-error-message').css("display", "block");
                                for (var error in response1.data.errors) {
                                    if (response1.data.errors[error].key === undefined ||
                                        response1.data.errors[error].key === '') {
                                        $('#importcsv-success-message').css("display", "none");
                                        $('#importcsv-error-message').css("display", "block");
                                        $('#importcsv-error-message')
                                            .append(response1.data.errors[error].value + '<br />');
                                    }
                                }
                            }
                        } else {
                            for (extensionCount = 0;
                                extensionCount < response1.data.errors["FileErrorType"].length;
                                extensionCount++) {
                                $('#importcsv-error-message')
                                    .append(response1.data.errors["FileErrorType"][extensionCount] + '<br />');
                            }
                            var imgLoading = document.getElementById("imgLoading");
                            imgLoading.style.visibility = "hidden";
                            $('#divImportCSV').children().attr("disabled", false);
                            $('#importcsv-success-message').css("display", "none");
                            $('#importcsv-error-message').css("display", "block");
                        }
                    }
                } else {

                    window.location.href = '/';
                }
            })
            .catch(function (response) {
                var errorPanel = document.getElementById('importcsv-error-message');
                errorPanel.innerText = response;
                errorPanel.style.display = "block";
                var imgLoading = document.getElementById("imgLoading");
                imgLoading.style.visibility = "hidden";
            })
            .finally(function () {
                $('.loading-box').hide();
            });
    }
}
$(document).ready(function () {
    var importcsv = new Importcsv();
    importcsv.Init();
});